<template>
    <div style="height: 100%">
        <h1
            class="title"
            style="margin-bottom: 10px; margin-top: 0; padding-top: 20px"
        >
            典型案例
        </h1>
        <div class="big-box">
            <template v-for="(item, index) in cases">
                <div
                    v-if="!isMobile"
                    :key="item.img"
                    class="box"
                    @click="part(index)"
                >
                    <div class="img-box">
                        <img :src="item.img" />
                    </div>
                    <div class="text-box">
                        <h2>{{ item.title }}</h2>
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </template>
            <div v-if="isMobile">
                <carousel></carousel>
                <car-one></car-one>
                <car-two></car-two>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose"
        >
            <div class="imgBox" style="height: 39vh">
                <button
                    class="nav-button prev-button"
                    @click="par()"
                    v-if="indexNum == 4 || indexNum == 11"
                >
                    &lt;
                </button>
                <button
                    class="nav-button next-button"
                    @click="next()"
                    v-if="indexNum == 4 || indexNum == 11"
                >
                    &gt;
                </button>
                <div style="height: 100%; width: 100%">
                    <img
                        :src="ImgUrl2"
                        style="height: 100%; width: 100%"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="tableBox"
                :style="{ height: indexNum == 3 ? '23vh' : '20vh' }"
            >
                <div
                    class="top"
                    :style="{ height: indexNum == 3 ? '13%' : '15%' }"
                >
                    <div class="left"><h3>客户单位</h3></div>
                    <div class="right">
                        <span>{{
                            indexNum3 > 11
                                ? tableText[indexNum3].name
                                : tableText[indexNum].name
                        }}</span>
                    </div>
                </div>
                <div class="bomTh" v-if="indexNum === 3">
                    <div class="left">
                        <div><h3>舒适度分析</h3></div>
                        <div><h3>可视性分析</h3></div>
                        <div><h3>可达性分析</h3></div>
                        <div><h3>碰撞干涉检查</h3></div>
                        <div><h3>多传感器接入</h3></div>
                        <div><h3>双人机组在线分析</h3></div>
                    </div>
                    <div class="right">
                        <div>
                            <p>
                                提供RULA和REBA分析模式，实时计算人体姿态并记录舒适度结果，并以三维方式在人体姿态上显示出舒适度结果。
                            </p>
                        </div>
                        <div>
                            <p>
                                支持专业的视野分析模式（Binocular、Ambinocular、Monocular
                                Left、Monocular
                                Right和Stereo），实时计算双眼聚焦点，可输出AOI区域注视时间。
                            </p>
                        </div>
                        <div>
                            <p>
                                支持人体多肢体的包络面检测，提供点、线和面模式分析模式，实时计算可达性结果并三维高亮显示。
                            </p>
                        </div>
                        <div>
                            <p>
                                全身肢体参与碰撞检查，实时记录碰撞的肢体与虚拟设备，可输出行为绩效结果。
                            </p>
                        </div>
                        <div>
                            <p>支持眼动和心率等设备的数据接入。</p>
                        </div>
                        <div>
                            <p>
                                采用多人协同架构，支持全身动捕系统，机组动作互相可见，设备操作实时反馈，分析计算实时记录。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="bom" v-else>
                    <div class="left"><h3>案例简介</h3></div>
                    <div
                        class="right"
                        :style="{ fontSize: indexNum == 4 ? '0.9em' : '1.1em' }"
                    >
                        <div>{{ processedString }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CarOne from "./CarOne.vue";
import Carousel from "./Carousel.vue";
import CarTwo from "./CarTwo.vue";
export default {
    components: { Carousel, CarTwo, CarOne },
    data() {
        return {
            cases: [
                {
                    img: require("@/assets/tecImg/图片1.png"),
                    title: "智慧检修仿真系统",
                    content: "客户单位：东方电气集团东方电机有限公司",
                },
                {
                    img: require("@/assets/tecImg/图片2.png"),
                    title: "红外&SAR仿真系统",
                    content: "客户单位：某高校&中航&中物院",
                },
                {
                    img: require("@/assets/tecImg/图片3.png"),
                    title: "综合演练系统",
                    content: "客户单位：某部队",
                },
                {
                    img: require("@/assets/tecImg/图片4.png"),
                    title: "人机工效评估系统",
                    content: "客户单位：商飞北研&中物院&沃飞长空",
                },
                {
                    img: require("@/assets/tecImg/图片5.png"),
                    title: "安全疏散仿真系统",
                    content: "客户单位：清华大学",
                },
                {
                    img: require("@/assets/tecImg/图片6.png"),
                    title: "Evotl系统",
                    content: "客户单位：小鹏汇天",
                },
                {
                    img: require("@/assets/tecImg/图片7.png"),
                    title: "无人机指挥控制模拟训练系统",
                    content: "客户单位：成都航空职业技术学院",
                },
                {
                    img: require("@/assets/tecImg/图片8.png"),
                    title: "人在环综合仿真验证系统",
                    content: "客户单位：商飞北研",
                },
                {
                    img: require("@/assets/tecImg/图片9.png"),
                    title: "飞行作战模拟训练系统",
                    content: "客户单位：中航某单位",
                },
                {
                    img: require("@/assets/tecImg/图片10.png"),
                    title: "XR模拟训练系统",
                    content: "客户单位：中航某单位",
                },
                {
                    img: require("@/assets/tecImg/图片12.png"),
                    title: "智能诊断系统",
                    content: "客户单位：东方电气集团东方电机有限公司",
                },
                {
                    img: require("@/assets/tecImg/图片13.png"),
                    title: "智慧工厂系统",
                    content: "客户单位：东电&某涡轮研究院",
                },
            ],
            tableText: [
                {
                    name: "东方电气集团东方电机有限公司",
                    value: "1、基于真实数据还原水电站场景、发电机、配套设备精确模型；2、跨平台应用，能够在多个硬件平台上完成虚拟训练操作（PC、VR、PAD和CAVE）；3、真实安装拆解流程三维还原，数十个课件培训以及考核，数千个可操作步骤；4、数字孪生应用接口，可接入真实传感器数据；5、二次开发接口，后续可增加课件以及便捷发布；6、提供典型案例、运行仿真、状态监测、专家讲解和检修培训模块；7、支持异地操作使用，按照权限开放相应的内容。",
                },
                {
                    name: "某高校&中航某单位&中物院某所",
                    value: "1、基于普朗克黑体辐射理论计算物体热辐射；2、基于SAR回波计算和目标RCS数据计算回波数据；3、解析Modtran数据为红外仿真提供大气路径辐射、透过率、太阳辐射、地球辐射和天空辐射等数据；4、支持火焰、爆炸、烟雾、扬尘和尾迹等特效仿真；5、支持外部数据实时驱动和控制；6、支持仿真图像和视频的保存和录制。",
                },
                {
                    name: "某部队",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、可模拟雨、雪和雾天气效果；3、可编辑战场单位元素、实时生成战场单位；4、支持导调指挥操作；5、支持多设备协同演练。",
                },
                {
                    name: "商飞北研&中物院&沃飞长空",
                    value: "",
                },
                {
                    name: "清华大学",
                    value: "1、支持生理数据采集设备的集成（肌电、脑电、近红外和眼动设备）；2、多平台支持（双视点CAVE、VR和PC）；3、快速的疏散场景制作；4、支持多端设备的协同仿真；5、支持疏散算法的集成和定制；6、支持FDS数据解析和渲染；7、支持人员轨迹、密度、速度、热力图显示；8、支持跑步机、光学动捕和惯性动捕设备。",
                },
                {
                    name: "小鹏汇天",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合实现；2、可模拟雨、雪和雾天气效果；3、基于GIS数据的城市建筑和道路自动生成，动态加载显示；4、典型地标建筑采用人工精细化建模；5、支持多通道投影融合和矫正（270度柱幕）；6、UDP仿真数据驱动。",
                },
                {
                    name: "成都航空职业技术学院",
                    value: "1、支持飞行控制训练、任务规划训练、任务载荷训练和链路监控训练；2、支持三维大地图的定制；3、飞行训练支持滑行、爬升、定高平飞、五边飞行和自由飞行科目；4、任务载荷支持武器规划、光电吊舱规划、SAR雷达规划和载荷控制；5、任务规划支持二维地图显示、航路点规划和起降航线规划；6、基于web技术，可通过浏览器访问使用。",
                },
                {
                    name: "商飞北研",
                    value: "1、全球大场景地形、卫星影像与地形贴图无缝混合现实；2、飞行器自动化构建，机场程序化构建，JSBSIM飞行仿真模块集成；3、多人在线仿真框架，支持多单位、部门的协同；4、支持人在环的人机工效评估。",
                },
                {
                    name: "某中航单位",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、模拟战斗机和武装直升机单机和联机作战；3、模拟飞行作战头盔显示画面；4、支持在VR/XR环境中使用。",
                },
                {
                    name: "某中航单位",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、模拟战斗机和武装直升机单机和联机作战；3、模拟飞行作战头盔显示画面；4、支持在VR/XR环境中使用。",
                },
                {
                    name: "东电",
                    value: "1、设备三维建模，实时数据驱动；2、健康指数显示；3、运行工况显示；4、报警显示；5、状态总览；6、系统诊断信息显示。",
                },
                {
                    name: "某涡轮研究院",
                    value: "1、真实车间、设备三维建模、场景还原；2、真实业务流程模拟；3、实时数据采集与状态显示；4、支持多种成像设备，如LED大屏。",
                },
                {
                    name: "东电&东锅&东树",
                    value: "1、真实车间、设备三维建模、场景还原；2、多摄像头数据集成；3、多类型图表数据显示；4、支持多种成像设备，如LED大屏。",
                },
            ],
            tableImg: [
                // { name: require("../assets/0/图片1.png") },
                // { name: require("../assets/1/图片3.png") },
                // { name: require("../assets/2/图片4.png") },
                // { name: require("../assets/3/图片5.png") },
                // { name: require("../assets/4/图片6.png") },
                // { name: require("../assets/4/图片7.png") },
                // { name: require("../assets/5/图片8.png") },
                // { name: require("../assets/6/图片9.png") },
                // { name: require("../assets/7/图片10.png") },
                // { name: require("../assets/8/图片11.png") },
                // { name: require("../assets/11/图片12.png") },
                // { name: require("../assets/12/图片13.png") },
                // { name: require("../assets/12/图片14.png") },
                // { name: require("../assets/12/图片15.png") },
                // { name: require("../assets/12/图片16.png") },
            ],
            ImgUrl: require("../assets/0/图片0.png"),
            ImgUrl2: require("../assets/0/图片0.png"),
            // {
            //     name: "东方电气集团东方电机有限公司",
            //     value: "1、基于真实数据还原水电站场景、发电机、配套设备精确模型；2、跨平台应用，能够在多个硬件平台上完成虚拟训练操作（PC、VR、PAD和CAVE）；3、真实安装拆解流程三维还原，数十个课件培训以及考核，数千个可操作步骤；4、数字孪生应用接口，可接入真实传感器数据；5、二次开发接口，后续可增加课件以及便捷发布；6、提供典型案例、运行仿真、状态监测、专家讲解和检修培训模块；7、支持异地操作使用，按照权限开放相应的内容。",
            // },
            // {
            //     name: "某高校&中航某单位&中物院某所",
            //     value: "1、基于普朗克黑体辐射理论计算物体热辐射；2、基于SAR回波计算和目标RCS数据计算回波数据；3、解析Modtran数据为红外仿真提供大气路径辐射、透过率、太阳辐射、地球辐射和天空辐射等数据；4、支持火焰、爆炸、烟雾、扬尘和尾迹等特效仿真；5、支持外部数据实时驱动和控制；6、支持仿真图像和视频的保存和录制。",
            // },
            // {
            //     name: "某部队",
            //     value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、可模拟雨、雪和雾天气效果；3、可编辑战场单位元素、实时生成战场单位；4、支持导调指挥操作；5、支持多设备协同演练。",
            // },
            // {
            //     name: "小鹏汇天",
            //     value: "1、真实大范围地形、卫星影像与地形贴图无缝混合实现；2、可模拟雨、雪和雾天气效果；3、基于GIS数据的城市建筑和道路自动生成，动态加载显示；4、典型地标建筑采用人工精细化建模；5、支持多通道投影融合和矫正（270度柱幕）；6、UDP仿真数据驱动。",
            // },
            // {
            //     name: "成都航空职业技术学院",
            //     value: "1、支持飞行控制训练、任务规划训练、任务载荷训练和链路监控训练；2、支持三维大地图的定制；3、飞行训练支持滑行、爬升、定高平飞、五边飞行和自由飞行科目；4、任务载荷支持武器规划、光电吊舱规划、SAR雷达规划和载荷控制；5、任务规划支持二维地图显示、航路点规划和起降航线规划；6、基于web技术，可通过浏览器访问使用。",
            // },
            // {
            //     name: "商飞北研",
            //     value: "1、全球大场景地形、卫星影像与地形贴图无缝混合现实；2、飞行器自动化构建，机场程序化构建，JSBSIM飞行仿真模块集成；3、多人在线仿真框架，支持多单位、部门的协同；4、支持人在环的人机工效评估。",
            // },
            // {
            //     name: "某中航单位",
            //     value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实；2、模拟战斗机和武装直升机单机和联机作战；3、模拟飞行作战头盔显示画面；4、支持在VR/XR环境中使用。",
            // },
            // {
            //     name: "商飞北研&中物院&沃飞长空",
            //     value: "",
            // },
            // {
            //     name: "清华大学",
            //     value: "1、支持生理数据采集设备的集成（肌电、脑电、近红外和眼动设备）；2、多平台支持（双视点CAVE、VR和PC）；3、快速的疏散场景制作；4、支持多端设备的协同仿真；5、支持疏散算法的集成和定制；6、支持FDS数据解析和渲染；7、支持人员轨迹、密度、速度、热力图显示；8、支持跑步机、光学动捕和惯性动捕设备。",
            // },
            // {
            //     name: "",
            //     value: "",
            // },
            // {
            //     name: "某涡轮研究院",
            //     value: "1、真实车间、设备三维建模、场景还原；2、真实业务流程模拟；3、实时数据采集与状态显示；4、支持多种成像设备，如LED大屏。",
            // },
            // {
            //     name: "东电&东锅&东树",
            //     value: "1、真实车间、设备三维建模、场景还原；2、真实业务流程模拟；3、实时数据采集与状态显示；4、支持多种成像设备，如LED大屏。",
            // },
            dialogVisible: false,
            indexNum: 0,
            indexNum2: 0,
            indexNum3: 0,
            isMobile: false,
        };
    },
    mounted() {
        this.isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        window.addEventListener("resize", this.checkDeviceType);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkDeviceType);
    },
    computed: {
        processedString() {
            const text = this.tableText[this.indexNum3].value;
            let parts = text.split(/(?=\d+、)/);
            let result = parts
                .map((part, index) => {
                    if (index > 0) {
                        return "\n" + part;
                    }
                    return part;
                })
                .join("");
            return result;
        },
    },
    watch: {
        indexNum() {
            this.ImgUrl2 = require(`../assets/${this.indexNum}/图片${this.indexNum2}.png`);
        },
        indexNum2() {
            this.ImgUrl2 = require(`../assets/${this.indexNum}/图片${this.indexNum2}.png`);
        },
        dialogVisible() {
            if (!this.dialogVisible) {
                this.indexNum = 0;
                this.indexNum2 = 0;
            }
        },
        isMobile() {
            console.log(this.isMobile);
        },
    },
    methods: {
        checkDeviceType() {
            this.isMobile =
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                );
        },
        part(num) {
            this.dialogVisible = true;
            this.indexNum = num;
            this.indexNum3 = num;
        },
        handleClose(done) {
            done();
        },
        par() {
            if (this.indexNum2 > 0) {
                this.indexNum2--;
            }
            if (this.indexNum3 == 12 && this.indexNum2 < 1) {
                this.indexNum3--;
            }
        },
        next() {
            if (this.indexNum == 4) {
                if (this.indexNum2 < 1) {
                    this.indexNum2++;
                }
            } else if (this.indexNum == 11) {
                if (this.indexNum2 < 3) {
                    this.indexNum2++;
                    if (this.indexNum3 == 11) {
                        this.indexNum3++;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-size: 36px;
    color: #fff;
    font-weight: 700;
    margin-left: 40px;
}
.big-box {
    // display: flex;
    width: 70%;
    margin: auto;
    height: 90%;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .box {
        width: 24%;
        height: 25%;
        font-weight: 700;
        border-radius: 5px;
        cursor: pointer;
        .img-box {
            height: 80%;
            width: 100%;
            opacity: 1;
            transition: opacity 0.3s ease;
            img {
                height: 100%;
                width: 100%;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
            }
        }
        .text-box {
            background-color: #fff;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            border-top: 1px solid #000;
            h2 {
                margin: 5px 0 0 0;
                padding-left: 10px;
            }
            p {
                padding-bottom: 10px;
                padding-left: 10px;
            }
        }
    }
    .box:hover {
        .img-box {
            opacity: 0.7;
        }
    }
}
.tableBox {
    margin-top: 10px;
    .top {
        border: 1px solid #ffac0b;
        height: 15%;
        width: 100%;
        display: flex;
        .left {
            width: 25%;
            height: 100%;
            border-right: 1px solid #ffac0b;
            text-align: center;
            line-height: 200%;
            color: #000;
            h3 {
                margin: 0;
            }
        }
        .right {
            width: 75%;
            height: 100%;
            font-size: 1.1em;
            color: #000;
            line-height: 2;
            span {
                margin-left: 15px;
            }
        }
    }
    .bom {
        border: 1px solid #ffac0b;
        border-top: none;
        height: 85%;
        width: 100%;
        display: flex;
        .left {
            width: 25%;
            height: 100%;
            border-right: 1px solid #ffac0b;
            text-align: center;
            line-height: 9;
            color: #000;
            h3 {
                margin: 0;
            }
        }
        .right {
            width: 75%;
            height: 100%;
            font-size: 1.1em;
            color: #000;
            line-height: 1.5;
            white-space: pre-wrap;
            display: flex;
            align-items: center;
            overflow: auto;
            div {
                margin-left: 15px;
            }
        }
    }
    .bomTh {
        border: 1px solid #ffac0b;
        border-top: none;
        height: 90%;
        width: 100%;
        display: flex;
        font-size: 0.9em;
        .left {
            width: 25%;
            border-right: 1px solid #ffac0b;
            text-align: center;
            color: #000;
            // line-height: 2;
            div {
                width: 100%;
                height: 14%;
                border-bottom: 1px solid #ffac0b;
                line-height: 200%;
                h3 {
                    margin: 0;
                }
            }
            div:nth-child(6) {
                border-bottom: none;
            }
            div:nth-child(1) {
                height: 20%;
            }
            div:nth-child(2) {
                height: 20%;
            }
        }
        .right {
            width: 75%;
            height: 100%;
            font-size: 1.1em;
            color: #000;
            line-height: 1.5;
            white-space: pre-wrap;
            // display: flex;
            align-items: center;
            overflow: auto;
            div {
                width: 100%;
                height: 14%;
                margin: auto;
                border-bottom: 1px solid #ffac0b;
                overflow-wrap: break-word;
                p {
                    margin: 0;
                    margin-left: 15px;
                    line-height: 20px;
                }
            }
            div:nth-child(6) {
                border-bottom: none;
            }
            div:nth-child(1) {
                height: 20%;
            }
            div:nth-child(2) {
                height: 20%;
            }
        }
    }
}
.imgBox {
    .nav-button {
        position: absolute;
        top: 32%;
        transform: translateY(-50%);
        background-color: rgba(0, 0, 0, 0.5);
        color: white;
        // padding: 10px 15px;
        height: 40px;
        width: 40px;
        border: none;
        border-radius: 20px;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 10;
    }

    /* 上一页按钮位置样式 */
    .prev-button {
        left: 10px;
    }

    /* 下一页按钮位置样式 */
    .next-button {
        right: 10px;
    }

    /* 当鼠标悬停在容器上时显示按钮 */
}
.imgBox:hover .nav-button {
    opacity: 1;
}
::v-deep .el-dialog__header {
    display: none;
}
::v-deep .el-dialog__body {
    padding: 15px;
    width: 96%;
    margin: auto;
}
@media (max-width: 798px) {
    .title {
        margin-left: 0;
        text-align: center;
    }
    .big-box {
        // display: flex;
        width: 87%;
        margin-left: 10%;
        height: 90%;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        div {
            width: 100%;
        }
    }
}
</style>